import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Input, Dropdown } from '@myplay/ui';

import I18N from '../../I18N';
import { NAME } from '../../utils/constants';
import { toTitleCase } from '../../utils/stringManipulations';

const seasons = [
  { years: "2018 - 2019", value: 2019 },
  { years: "2019 - 2020", value: 2020 },
  { years: "2020 - 2021", value: 2021 }
]

const AddTeamInputsPanel = ({ 
  onChangeName, 
  SitesStore, 
  CategoriesStore, 
  teamName, 
  onSelectSite, 
  onSportSelect, 
  onSelectSeason, 
  selectedSite, 
  selectedCategory, 
  selectedSeason 
}) => {
  const { sites } = SitesStore;

  return (
    <div className="add-team-modal__inputs-container">
      <div className="add-team-modal__inputs-container__input-wrapper">
        <Input
          type="text"
          label={toTitleCase(I18N.t("TEAM_NAME"))}
          onChange={event => onChangeName(event.target.value)} 
          value={teamName}
        />
      </div>
      <div className="add-team-modal__inputs-container__input-wrapper">
        <Dropdown 
          placeholder={toTitleCase(I18N.t("SEASON"))} 
          items={seasons} 
          displayedProperty="years"
          style={{ flexBasis: "45%" }}
          onSelect={onSelectSeason}
          selectedItem={selectedSeason && seasons.filter(season => season.value === selectedSeason)[0]}
        />
      </div>
      <div className="add-team-modal__inputs-container__input-wrapper">
        <Dropdown 
          placeholder={toTitleCase(I18N.t("SPORT"))} 
          items={CategoriesStore.categories} 
          displayedProperty={NAME}
          style={{ flexBasis: "45%" }}
          onSelect={onSportSelect}
          selectedItem={selectedCategory && { name: selectedCategory.name }}
        />
      </div>
      <div className="add-team-modal__inputs-container__input-wrapper">
        <Dropdown 
          placeholder={toTitleCase(I18N.t("MAIN_COURT"))} 
          items={sites} 
          displayedProperty={NAME}
          style={{ flexBasis: "45%" }}
          onSelect={onSelectSite}
          selectedItem={selectedSite}
        />
      </div>
    </div>
  );
};

AddTeamInputsPanel.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

AddTeamInputsPanel.defaultProps = {
  inputs: {}, 
  onChange: ()=> {}
};

export default inject("SitesStore", "CategoriesStore")(observer(AddTeamInputsPanel));